import { BfnStatus } from '@/models/Befehlsnachricht'
import { BfnStoreDataEntry } from '@/store/useBfnStore'
import BfnStatusInfoStandorteingabeDurchFdl from './BfnStatusInfoStandorteingabeDurchFdl'

export interface BfnStatusInfoProps {
  bfnDataEntry: BfnStoreDataEntry
  'data-testid': string
}

export default function BfnStatusInfo({
  bfnDataEntry,
  'data-testid': testId
}: Readonly<BfnStatusInfoProps>) {
  if (
    bfnDataEntry.befehlsnachricht.status ===
    BfnStatus.STANDORTABGLEICH_DURCH_FDL_ERFORDERLICH
  ) {
    return (
      <BfnStatusInfoStandorteingabeDurchFdl
        standortSentDate={bfnDataEntry.standortSentDate}
        data-testid={`${testId}-standort-eingabe-fdl`}
      />
    )
  }

  return null
}
